import { render, staticRenderFns } from "./RiskCard.vue?vue&type=template&id=6b77ea29&scoped=true"
import script from "./RiskCard.vue?vue&type=script&lang=js"
export * from "./RiskCard.vue?vue&type=script&lang=js"
import style0 from "./RiskCard.vue?vue&type=style&index=0&id=6b77ea29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b77ea29",
  null
  
)

export default component.exports